import React from 'react';
import { useCart } from '../context/CartContext';
export function Kids() {
  const {
    addToCart
  } = useCart();
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-586">
      <div className="max-w-[1800px] mx-auto" data-id="element-587">
        <header className="mb-20 text-center" data-id="element-588">
          <span className="text-xs md:text-sm font-display font-bold uppercase tracking-[0.5em] mb-4 block text-black/40" data-id="element-589">
            The Next Generation
          </span>
          <h1 className="text-2xl sm:text-4xl md:text-6xl font-display font-bold tracking-[0.05em] md:tracking-[0.2em] uppercase mb-6" data-id="element-590">
            Kids
          </h1>
          <p className="max-w-xl mx-auto text-sm md:text-base font-light tracking-widest text-black/60 leading-relaxed uppercase" data-id="element-591">
            Playful heritage for the little ones. Traditional textiles in
            comfortable, modern cuts.
          </p>
        </header>
        <div className="flex justify-center" data-id="element-592">
          <div className="max-w-md group" data-id="element-593">
            <div className="aspect-[3/4] bg-grey-divider overflow-hidden mb-6 relative" data-id="element-594">
              <img src="https://cdn.magicpatterns.com/uploads/jEej3XExu4hp2w3M59neD7/image.png" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" alt="Kids" data-id="element-595" />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all flex items-center justify-center opacity-0 group-hover:opacity-100" data-id="element-596">
                <button onClick={() => addToCart({
                id: 'kids-junior-heritage',
                name: 'Junior Heritage Set',
                price: '$180.00',
                image: 'https://cdn.magicpatterns.com/uploads/jEej3XExu4hp2w3M59neD7/image.png',
                quantity: 1,
                size: 'OS'
              })} className="bg-white text-black px-6 py-3 text-xs font-display font-bold uppercase tracking-widest hover:bg-black hover:text-white transition-colors" data-id="element-597">
                  Add to Bag
                </button>
              </div>
            </div>
            <div className="flex justify-between items-start" data-id="element-598">
              <div data-id="element-599">
                <h3 className="text-xs md:text-sm font-display font-bold tracking-widest uppercase mb-1" data-id="element-600">
                  Junior Heritage Set
                </h3>
                <p className="text-sm font-light text-black/50" data-id="element-601">$180.00</p>
              </div>
              <button onClick={() => addToCart({
              id: 'kids-junior-heritage',
              name: 'Junior Heritage Set',
              price: '$180.00',
              image: 'https://cdn.magicpatterns.com/uploads/jEej3XExu4hp2w3M59neD7/image.png',
              quantity: 1,
              size: 'OS'
            })} className="md:hidden text-xs font-display font-bold uppercase tracking-widest border-b border-black pb-0.5" data-id="element-602">
                Add to Bag
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}